import clsx from 'clsx';
import { memo } from 'react';

import './Connector.css';

export type ConnectorStatus = 'completed' | 'current' | 'future';

export type ConnectorProps = {
  /** How far the sequence has advanced through this connection. */
  status: ConnectorStatus;
  /** Orientation of the sequence this connector belongs to. Set by `Steps`. */
  direction?: 'horizontal' | 'vertical';
};

export const Connector = memo(function Connector({
  status,
  direction = 'horizontal',
}: ConnectorProps) {
  return (
    <div
      aria-hidden
      className={clsx(
        'eds-connector',
        `eds-connector--${status}`,
        direction === 'vertical' && 'eds-connector--direction-vertical',
      )}
    />
  );
});
